export const CONTACT_SOCIALS = [
  { label: 'Linkedin', value: 'linkedin' },
  { label: 'Facebook', value: 'facebook' },
  { label: 'Twitter', value: 'twitter' },
  { label: 'Instagram', value: 'instagram' },
  { label: 'Stack overflow', value: 'stackoverflow' },
  { label: 'Website', value: 'website' },
  { label: 'Github', value: 'github' },
];

export const DEGREE_LIST = [
  {
    id: 1,
    name: 'Primary education',
  },
  {
    id: 2,
    name: 'Lower secondary education',
  },
  {
    id: 3,
    name: 'Upper secondary education',
  },
  {
    id: 4,
    name: 'Post-secondary non-tertiary education',
  },
  {
    id: 5,
    name: 'Short-cycle tertiary education',
  },
  {
    id: 6,
    name: "Bachelor's or equivalent",
  },
  {
    id: 7,
    name: "Master's or equivalent",
  },
  {
    id: 8,
    name: 'Doctor or equivalent',
  },
  {
    id: 9,
    name: "Bachelor's Degree",
  },
  {
    id: 10,
    name: "Engineer's Degree",
  },
  {
    id: 11,
    name: 'High School',
  },
  {
    id: 12,
    name: 'Doctor of Philosophy (Ph.D.)',
  },
  {
    id: 13,
    name: 'Juris Doctor (J.D.)',
  },
  {
    id: 14,
    name: "Master's Degree",
  },
  {
    id: 15,
    name: 'Other',
  },
];
